export const AppConstants = {
  EVIDENCE_MAIN_VERSION: '3.0.0'
}
